import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Heading,
  Progress,
  Text,
} from "@chakra-ui/react";
// import revenuePercentage from "../../assets/percentage.png";
import { GrLineChart } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import { useQueryWrapper } from "services/apiHelper";
import { userAnalyticRequest } from "services/request";
import { QUERY_KEYS } from "utils/constants";
import { PROTECTED_PATHS } from "routes/pagePath";
import { MySpinner } from "components/CustomSpinner";
import { useMemo } from "react";

const AdminDashboardLayout = () => {
  const navigate = useNavigate();
  const routes = PROTECTED_PATHS;

  const {
    data: userDetails = {},
    isLoading,
    refetch: refetchUserDetails,
  } = useQueryWrapper(QUERY_KEYS.USER_ANALYTICS, userAnalyticRequest.USERS_ANALYTIC);

  const { data: analyticsSummary = {} } = useQueryWrapper(
    QUERY_KEYS.REVENUE_ANALYTICS,
    userAnalyticRequest.USERS_SUMMARY,
  );

  const revenueSummary = useMemo(() => analyticsSummary?.data?.revenue || [], [analyticsSummary]);

  const singlePurchasesSummary = useMemo(
    () => analyticsSummary?.data?.singlePurchases,
    [analyticsSummary],
  );

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <MySpinner />
      </Box>
    );
  }

  const userSummary = userDetails?.summary;

  if (!userSummary) {
    return (
      <Box px="40px" mt="20px">
        <Alert status="error" borderRadius="md">
          <AlertIcon />
          <AlertDescription flex="1">
            Couldn&apos;t load dashboard data. The server may be temporarily unavailable.
          </AlertDescription>
          <Button
            size="sm"
            onClick={() => {
              refetchUserDetails().catch(() => undefined);
            }}
          >
            Retry
          </Button>
        </Alert>
      </Box>
    );
  }

  const { allUsers, subscribed } = userSummary;

  const items = [
    {
      title: "Users",
      number: allUsers,
      text: "Registered Users",
      percentage: Math.round((allUsers / allUsers) * 100),
      color: "orange",
      navigateTo: () => {
        navigate(routes.USERS_CATEGORY);
      },
    },
    {
      title: "Revenue",
      amount: revenueSummary[0],
      text: "All Revenue",
      percentage: Math.round((subscribed / allUsers) * 100),
      color: "green",
      navigateTo: () => {
        navigate(routes.REVENUE);
      },
    },

    {
      title: "Download History",
      number: 8451,
      text: "Downloads",
      percentage: 60,
      color: "green",
      navigateTo: () => {
        navigate("/downloads");
      },
    },

    {
      title: "Single Purchases",
      number: singlePurchasesSummary?.count ?? 0,
      text: "Scripts Sold Individually",
      percentage: Math.round((singlePurchasesSummary?.count / allUsers) * 100) || 0,
      color: "orange",
      navigateTo: () => {
        navigate(routes.SINGLE_PURCHASES);
      },
    },
  ];

  return (
    <Box px="40px">
      <Flex justify={"space-between"} mt={"20px"} align="center">
        <Text fontSize="20px" fontWeight="500">
          Dashboard
        </Text>
        <Box
          display={{
            base: "none",
            lg: "block",
            xl: "block",
          }}
        ></Box>
      </Flex>

      <Grid
        gridTemplateColumns={{
          md: "repeat(2, 1fr)",

          xl: "repeat(4, 1fr)",
        }}
        display={{
          base: "block",
          md: "grid",
          xl: "grid",
        }}
        mt="20px"
        gridGap="24px"
      >
        {items.map((item, index) => {
          return (
            <GridItem
              key={index + 1}
              p="30px 20px"
              mb={{
                base: "10px",
                md: "0",
                lg: "0",
              }}
              bg="#FFFFFF"
              borderRadius="10px"
              border="1px solid #E0E6DD"
              cursor="pointer"
              onClick={item.navigateTo}
            >
              <Box>
                <Flex justifyContent="space-between" mt="-20px">
                  <Text fontSize="16px" fontWeight="400" color="black">
                    {item.title}
                  </Text>
                </Flex>

                <Flex justifyContent="space-between" align="center" mt="20px">
                  {/* {item?.number && ( */}
                  <Flex
                    bg={item.color}
                    borderRadius="15px"
                    px="10px"
                    py="5px"
                    alignItems="center"
                    color="white"
                  >
                    <Text fontSize="10px" pr="5px" fontWeight="900">
                      {String(item.percentage) + "%"}
                    </Text>
                    <GrLineChart size="12px" color="white" />
                  </Flex>
                  {/* )} */}

                  <Box>
                    {item?.number && (
                      <Heading textAlign="end" fontSize="25px" fontWeight="800">
                        {item.number}
                      </Heading>
                    )}

                    {item?.amount && (
                      <Heading textAlign="end" fontSize="25px" fontWeight="800">
                        {new Intl.NumberFormat(`en-${item?.amount?.currency.slice(0, -1)}`, {
                          style: "currency",
                          currency: item?.amount.currency,
                        }).format(Math.round(Number(item?.amount.totalAmountCollected)))}
                      </Heading>
                    )}

                    <Text color="#bdc2ba" mt="5px">
                      {item.text}
                    </Text>
                  </Box>
                </Flex>
              </Box>

              <Progress value={item.percentage} size="xs" colorScheme={item.color} mt="20px" />
            </GridItem>
          );
        })}
      </Grid>
    </Box>
  );
};

export default AdminDashboardLayout;
